import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext, useEffect } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Chart from '@reuters-graphics/chart-module-vaccination-countries';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import { useRouter } from 'next/router';

const atlas = new AtlasMetadataClient();

const chart = new Chart();

const CountriesChartContainer = (props) => {
  const { vaccinationData } = props;

  const chartContainer = React.createRef();

  const router = useRouter();
  const content = useContext(ContentContext);
  const countrySlug = useContext(CountryContext);
  const locale = useContext(LocaleContext);

  const onNavigate = () => {
    window.scrollTo(0, 0);
    document.body.focus();
  };

  useEffect(() => {
    chart
      .selection(chartContainer.current)
      .data(vaccinationData.filter(d => d.population > 1000000).map(d => ({ ...d })))
      .props({
        // aspectHeight: 2,
        padding: 0.5,
        margin: { left: 80, right: 10 },
        countryNameGetter: (d) => {
          const country = atlas.getCountry(d);
          if (country.abbreviations[locale]) return country.abbreviations[locale];
          return atlas.getCountry(d).translations[locale];
        },
        rectFill: 'rgba(163, 190, 140, 0.5)',
        // rectFill: 'rgb(230, 147, 77)',
        strokeDasharray: '5 5',
        annotationStroke: 'rgba(255,255,255,0.75)',
        axisMarginCharacter: 4,
        text: {
          milestone: content.template.vaccination.chart.milestone.major,
          milestoneMinor: content.template.vaccination.chart.milestone.minor,
        },
        topText: content.template.vaccination.chart.axisLabel,
        countryLinks: (slug) => {
          if (locale === 'en') {
            router.push('/countries-and-territories/[region]', `/countries-and-territories/${slug}`)
              .then(onNavigate);
          } else {
            router.push('/[locale]/countries-and-territories/[region]', `/${locale}/countries-and-territories/${slug}`)
              .then(onNavigate);
          }
        },
      })
      .draw();
  }, [vaccinationData, countrySlug, chartContainer, content, locale, router]);

  const resize = debounce(() => {
    if (!chartContainer.current) return;
    chart.draw();
  }, 250);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={classnames(component)}>
      <h6>{content.template.vaccination.chart.title}</h6>
      <div className='vaccination-countries-container' ref={chartContainer} />
      <p className='footnote'>{content.template.vaccination.chart.footnote}</p>
    </div>
  );
};

export default CountriesChartContainer;
